var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveMember(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 25.75C24.9812 25.75 23.75 26.9812 23.75 28.5C23.75 29.0004 23.8832 29.4691 24.1167 29.8732L27.8732 26.1167C27.4691 25.8832 27.0004 25.75 26.5 25.75ZM28.9196 27.1916L25.1916 30.9196C25.5806 31.1305 26.0261 31.25 26.5 31.25C28.0188 31.25 29.25 30.0188 29.25 28.5C29.25 28.0261 29.1305 27.5806 28.9196 27.1916ZM22.25 28.5C22.25 26.1528 24.1528 24.25 26.5 24.25C27.689 24.25 28.7652 24.7393 29.5357 25.5256C30.2861 26.2914 30.75 27.3423 30.75 28.5C30.75 30.8472 28.8472 32.75 26.5 32.75C25.3423 32.75 24.2914 32.2861 23.5256 31.5357C22.7393 30.7652 22.25 29.689 22.25 28.5Z",
    fill: "#FF4D68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16C26 18.2091 24.2091 20 22 20C19.7909 20 18 18.2091 18 16C18 13.7909 19.7909 12 22 12C24.2091 12 26 13.7909 26 16Z",
    fill: "#FF4D68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2951 23.1879C22.2137 24.0529 20.75 26.1055 20.75 28.5C20.75 29.8163 21.1943 31.0315 21.9378 32C14 31.9895 14 29.9788 14 27.5C14 25.0147 17.5817 23 22 23C22.7977 23 23.5681 23.0657 24.2951 23.1879Z",
    fill: "#FF4D68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveMember);
export default __webpack_public_path__ + "static/media/inactive-member.2807a1c13f2c41b7ce1f1de5d9b64b9e.svg";
export { ForwardRef as ReactComponent };